module.exports = __webpack_public_path__ + "img/unday-bg.7c21709f.png";